import { render, staticRenderFns } from "./my_homebot.vue?vue&type=template&id=7bba6212&scoped=true&"
import script from "./my_homebot.vue?vue&type=script&lang=js&"
export * from "./my_homebot.vue?vue&type=script&lang=js&"
import style0 from "./my_homebot.vue?vue&type=style&index=0&id=7bba6212&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bba6212",
  null
  
)

export default component.exports